import {on, find, findIn, findAllIn, addClass, removeClass, hasClass} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";


export function init () {
    onFind(".js-close-accordion", function (element) {
        const isMobile = () => matchMedia('(max-width: 767px)').matches;
        let accordionCollapseBtn = findIn('.js-close-accordion__collapse-btn', element);
        let accordionCollapseContent = findIn('.js-close-accordion__collapse-content', element);
        if(isMobile()){
            let height = accordionCollapseContent.offsetHeight;
            if(height > 500){
                removeClass('show', accordionCollapseContent);
                addClass('collapsed', accordionCollapseBtn);
            }
        }
    });
}
